import { FoodCollectionDetail } from "@corpuscomplete/core-ui/nutrition/food-collection/detail";
import { FoodCollectionDetailPage } from "@corpuscomplete/web/modules/nutrition/food-collection/pages/food-collection-detail";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/collections/food/$id")({
  component: () => {
    const { id } = Route.useParams();
    return <FoodCollectionDetailPage id={id} />;
  },
  loader: async ({ context: { zero }, params: { id } }) => {
    if (zero) {
      FoodCollectionDetail.preload(zero, id);
    }
  },
});
